<template>
<div class="chapter">
<div class="inner_page">
<p class="C107"><a id="page_vii">CONTENTS</a></p><a id="page_vii">
</a><p class="C110"><a id="page_vii"></a><a href="#/xhtml/05_Acknowle#page_ix">Acknowledgments</a></p>
<p class="C112"><a href="#/xhtml/06_Introduc#page_1">Introduction</a></p>
<p class="C110"><a href="#/xhtml/07_Chapter#page_20">CHAPTER 1. <em>Toward a Revised History of Modesty and Humility</em></a></p>
<p class="C110"><span href="#/xhtml/08_Chapter#page_44" title="Link target outside of Sample">CHAPTER 2. <em>Modesty: Hobbes on How Mere Mortals Can Create a Mortal God</em></span></p>
<p class="C110"><span href="#/xhtml/09_Chapter#page_70" title="Link target outside of Sample">CHAPTER 3. <em>Humility: Spinoza on the Joys of Finitude</em></span></p>
<p class="C110"><span href="#/xhtml/10_Chapter#page_105" title="Link target outside of Sample">CHAPTER 4. <em>Self-Love: Rousseau on the Allure, and the Elusiveness, of Divine Self-Sufficiency</em></span></p>
<p class="C112"><span href="#/xhtml/11_Conclusi#page_140" title="Link target outside of Sample">CONCLUSION. <em>A Modest Tale about Theoretical Modesty</em></span></p>
<p class="C110"><span href="#/xhtml/12_Notes#page_159" title="Link target outside of Sample">Notes</span></p>
<p class="C110"><span href="#/xhtml/13_Bibliogr#page_213" title="Link target outside of Sample">Bibliography</span></p>
<p class="C110"><span href="#/xhtml/14_Index#page_229" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?30dcf74c